var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/threadicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Thread",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6578236,0 C7.2733682,-0.00487001799 4.15271669,1.82840041 2.50707282,4.78828665 C0.861428952,7.74817289 0.949909343,11.3686229 2.73817252,14.2444485 L0,20 L5.74989584,17.2595575 C9.11259725,19.3520226 13.4289699,19.0910325 16.5155083,16.6086132 C19.6020468,14.1261939 20.7857069,9.9636565 19.4677154,6.22668649 C18.1497239,2.48971647 14.6174794,-0.00681020874 10.6578236,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.65936346,
    y1: 6.66667597,
    x2: 14.6527312,
    y2: 6.66667597,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.3271355,
    y1: 9.33334078,
    x2: 15.9849591,
    y2: 9.33334078,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.65936346,
    y1: 12.0000056,
    x2: 14.6527312,
    y2: 12.0000056,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadicon);
export default __webpack_public_path__ + "static/media/threadicon.6d924169ded9f8ce0298af00167db980.svg";
export { ForwardRef as ReactComponent };